export function matchPartialDeviceInformation(compareDevice, currentDeviceInformation) {
    if (!compareDevice) {
        return false;
    }
    var compareKeys = [
        'browserName',
        'browserVersion',
        'deviceBrand',
        'deviceManufacturer',
        'deviceModel',
        'deviceFullModel',
        'deviceType',
        'deviceVersion',
        'deviceFirmware',
        'frameworkName',
        'frameworkVersion',
        'operatingSystemName',
        'operatingSystemVersion'
    ];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = compareKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (compareDevice[key] && compareDevice[key] !== currentDeviceInformation[key]) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}

//# sourceMappingURL=device-information.js.map